export const galleyImageOptions = {
  angle: 'galley',
  staticOptions: {
    Veneer: 1,
    Floorboard: 1,
    Fabric: 1,
    CupboardsSaloon: 1,
    CupboardsOwnersCabin: 1,
    SplitBerth: 1,
    Backrest: 1,
    TableBox: 1,
    Pouffes: 1,
    FabricOwnersCabin: 1,
    FabricAftCabin: 1,
    AftCabinShelving: 1
  },
  mattes: [
    {
      option: 'Veneer',
      dependency: null
    },
    {
      option: 'Floorboard',
      dependency: 'Pouffes'
    },
    {
      option: 'Fabric',
      dependency: 'Worktop'
    },
    {
      option: 'CupboardsSaloon',
      dependency: 'Veneer'
    },
    {
      option: 'Backrest',
      dependency: 'Fabric'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/X46/views/galley.js